import { render, staticRenderFns } from "./ProductDetailFlyout.vue?vue&type=template&id=e545792e&scoped=true&"
import script from "./ProductDetailFlyout.vue?vue&type=script&lang=js&"
export * from "./ProductDetailFlyout.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailFlyout.vue?vue&type=style&index=0&id=e545792e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e545792e",
  null
  
)

export default component.exports